import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

import { observer } from "mobx-react-lite";
import { useStore } from "@/app/providers/StoreProvider";
import { GameState } from "../types";
import { PreloadedImages } from "@/shared/utils/preload";

type Star = {
  id: number;
  x: number;
  y: number;
  scale: number;
  rotation: number;
};

export const Indicators = observer(() => {

  const [stars, setStars] = useState<Star[]>([]);

  const { gameStore } = useStore();
  const {gameState,currentHitInstant} = gameStore;
  const count = 15;

  const duration = 0.8;

  useEffect(() => {
    if(gameState !== GameState.kickEnd && gameState !== GameState.fireAnim && gameState !== GameState.await) return

    if(gameState == GameState.kickEnd){
      const newStars = Array.from({ length: count }, (_, i) => ({
        id: i,
        x: (Math.random() - 0.5) * 500,
        y: (Math.random() - 0.5) * 500,
        scale: (Math.random() - 0.5) * 0.8,
        rotation: Math.random() * 180,
      }));
    
      setStars(newStars);
    }
    const timer = setTimeout(() => {
      setStars([]);
      
      if(gameState == GameState.await){
        gameStore.setGameContinue();
      }

    }, duration * 1000);

    return () => clearTimeout(timer);

  }, [gameState]);
  if(currentHitInstant == null) return null
  if((gameState !== GameState.kickEnd && gameState !== GameState.fireAnim && gameState !== GameState.await)) return null

  return (
    <div className="indicator-container">
    {currentHitInstant === true&&
        <>
            <motion.img
                key='goal'
                src={PreloadedImages.goal.src}
                alt="goal"
                initial={{ scale: 0.2, rotate:-30, opacity: 0 }}
                animate={{ scale: 1,rotate:0, opacity: [0,0.5,1,0] }}
                transition={{
                  duration:duration,
                  ease: "easeOut",
                }}
                style={{
                  position: "absolute",
                  maxWidth:450,
                  zIndex:999
                }}
            />
            {stars.map((star) => (
              <motion.div
                key={star.id}
                initial={{ x: 0, y: 0, opacity: 0, scale: 0, rotate: 0 }}
                animate={{
                  x: star.x,
                  y: star.y,
                  opacity: [0,0.5,1,0],
                  scale: star.scale,
                  rotate: star.rotation,
                }}
                transition={{
                  duration:duration,
                  ease: "easeOut",
                }}
                style={{ 
                  position: "absolute",
                  zIndex: 99 
                }}
              >
                <img src={PreloadedImages.star.src} alt="star" />
              </motion.div>
            ))}
        </> 
    }
    {
      currentHitInstant === false&&
        <motion.img
        key='miss'
        src={PreloadedImages.miss.src}
        alt="miss"
        initial={{ scale: 1.6, opacity: 0 }}
        animate={{
          scale: 1,
          opacity: [0,0.5,1,0.5,0],
        }}
        transition={{
          scale: {
            type: "spring",
            stiffness: 200,
            damping: 10,
          },
          opacity: {
            ease: "easeIn",
            duration: duration,
          },
        }}
        style={{
          position: "absolute",
          maxWidth: 450,
          zIndex:999
        }}
    />
    }


    </div>
  );
});